module.exports = __webpack_public_path__ + "img/NIO_LOGO_white@3x.01dba268.png";